import { api, apiFile } from "api/api";
import { AxiosError } from "axios";
import HelpdeskTramite from "model/helpdesk/HelpdeskTramite";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class HelpdeskTramiteService implements BaseServiceCadastros<HelpdeskTramite> {

    pesquisar(page: Pageable, filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/helpdeskTramite/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => {
                    reject(err.response);
                    console.error('Error status:', err.response?.status);
                    console.error('Error details:', err.response?.data);
                })
        });
    }

    consultar(id: number) {
        return new Promise<HelpdeskTramite>((resolve, reject): void => {
            api
                .get(`/helpdeskTramite/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(data: FormData) {
        return new Promise<HelpdeskTramite>((resolve, reject): void => {
            apiFile
                .post(`/helpdeskTramite/incluir`, data)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(data: FormData) {
        return new Promise<HelpdeskTramite>((resolve, reject): void => {
            apiFile
                .put(`/helpdeskTramite/editar`, data)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/helpdeskTramite/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    gerar(data: FormData) {
        return new Promise<HelpdeskTramite>((resolve, reject): void => {
            apiFile
                .post(`/helpdeskTramite/gerar`, data)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default HelpdeskTramiteService;